declare global {
  interface Window { __reframeInteracted?: boolean; }
}
/** One trusted interaction, with no load/idle/timer fallback. */
export function afterFirstInteraction(callback: () => void): () => void {
  const events = ["pointerdown", "keydown", "touchstart", "scroll", "mousemove"] as const;
  function cleanup() { events.forEach((event) => window.removeEventListener(event, start)); }
  function start(event: Event) {
    if (!event.isTrusted) return;
    window.__reframeInteracted = true;
    cleanup();
    callback();
  }
  if (window.__reframeInteracted) { callback(); return () => {}; }
  events.forEach((event) => window.addEventListener(event, start, { passive: true }));
  return cleanup;
}
